// 기존 스펙 유지를 위해 기존 코드 base로 수정
export const highlight = ({ item, query, tag }) => {
  const regex = new RegExp(`(${getHighlightRegex(query)})`, 'gi')
  return regex.test(item) ? item.replace(regex, `<${tag}>${RegExp.$1}</${tag}>`) : item
}

// 공백 제거후 배열로 변환
export const convertStringToArray = (query: string): string[] => {
  return query.match(/\S/g)
}

export const getHighlightRegex = (query: string): string => {
  const escapeRegex = new RegExp('[.*+?|()\\[\\]{}\\\\]', 'g')

  // 질의어 사이사이에 공백 삽입, 앞뒤 공백 제거, 정규표현식 문자열 escape 처리, 여러개의 공백을 [\\s]* 으로 변경 (ex) 질의어에 ' [aa aa a ' 가 유입시, '\[[\\s]*a[\\s]*a[\\s]*a[\\s]*a[\\s]*a' 로 변경)
  const removedEmptyQuery = query.replace(/()/g, ' ').replace(/^\s+|\s+$/g, '')
  const convertedArrayQuery = convertStringToArray(removedEmptyQuery)

  const result = convertedArrayQuery.reduce((prev, current) => {
    return [
      ...prev,
      current.replace(/[\S]+/g, `[${current.replace(escapeRegex, '\\$&')}] `).replace(/[\s]+/g, '[\\s]*'),
    ]
  }, [])

  return result.join('')
}
